module.exports = __webpack_public_path__ + "img/logo.9c17a304.png";